const apiKey = '9qSb8bYXDABhKCYBUs5kA5EUuAnISy4R';
/**
 * Get an API response.
 * @param {string} url
 * @returns {Array} array
 */
export default function getTrustpilot(url) {
  // Set up the request headers
  const headers = new Headers();
  headers.append('apikey', apiKey);

  return fetch(url, { method: 'GET', headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.error('Error fetching business unit information', error);
    });
}
